// pages/Dashboard.jsx
import MyOrders from "../../components/home/orderComponents/MyOrders";
import HomeLayout from "../../components/home/HomeLayout";

export default function Dashboard() {
  return (
    <HomeLayout>
      <MyOrders />
    </HomeLayout>
  );
}
